// extracted by mini-css-extract-plugin
module.exports = {"title":"SideFaq_title__2x5XO","point":"SideFaq_point__N5bGG"};